import React, { useEffect, useState } from 'react';
import './TaskPage.css';
import { TaskItem } from '../b2ai-tasks/models';
import { useKeycloak } from '../../services/KeycloakProvider';
import { useLocalStorage } from '../../services/LocalStorageProvider';
import { GainProfile } from '../b2ai-tasks/acoustic-tasks/common/SubTaskView';
import { ProfileName } from '../b2ai-tasks/acoustic-tasks/common/models';
import TaskView from '../b2ai-tasks/TaskView';
import { useNavigate, useParams } from 'react-router-dom';
import { useStorage } from '../../services/StorageProvider';
import { AudioCheckDefinition } from '../b2ai-tasks/acoustic-tasks/generic';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const TaskPage = () => {
  const navigate = useNavigate();
  const { taskName } = useParams();
  const { storage } = useStorage();
  const { storage: localStorage } = useLocalStorage();
  const { userInfo } = useKeycloak();
  const { t } = useTranslation();
  const [participantId, setParticipantId] = useState<string | null>(null);

  const session = storage.session;
  const [task, setTask] = useState<TaskItem | null>(null);

  useEffect(() => {
    if (userInfo && userInfo.subjectId && userInfo.subjectId !== participantId) {
      setParticipantId(userInfo.subjectId);
    }
  }, [userInfo, participantId]);

  useEffect(() => {
    if (taskName && session) {
      const foundTask = storage.tasks.find((task: any) => task.name === taskName);
      if (foundTask) {
        setTask(foundTask);
      }
    }
  }, [taskName, session, storage.tasks]);

  useEffect(() => {
    if (!session) {
      console.log('No session, redirecting to tasks page');
      navigate('/data-collection/tasks');
    }
  }, [session, navigate]);

  useEffect(() => {
    if (!task || task.type !== 'acoustic-task') { return; }

    if (task.name === AudioCheckDefinition.name) { return; }

    const gainProfiles: GainProfile[] = localStorage.gainProfiles ?? [];
    const requiredGainProfiles: ProfileName[] = ['speech', 'cough', 'breathe'];
    const requiredGainProfilesExist = requiredGainProfiles.every(name =>
      gainProfiles.some(profile => profile.name === name)
    );

    console.log('Required gain profiles exist:', requiredGainProfilesExist);
    if (!requiredGainProfilesExist) {
      console.log('No gain profiles, redirecting to tasks page');
      navigate('/data-collection/tasks');
    }
  }, [localStorage.gainProfiles, task, navigate]);

  useEffect(() => {
    if (userInfo && userInfo.subjectId && userInfo.subjectId !== participantId) {
      setParticipantId(userInfo.subjectId);
    }
  }, [userInfo, participantId]);

  const handleOnTaskCompletion = (task: TaskItem) => {
    task.status = 'completed';
    console.log(`${task.name} completed`);
    navigate('/data-collection/tasks');
  };

  return (
    <div className="task-page">
      {task
        ? <TaskView task={task} onCompletion={handleOnTaskCompletion} />
        : <CircularProgress role="status" aria-label={t("Loading task")} />
      }
    </div>
  );
};
